import { monospaceFont } from '@phishtool/ui';
import { createGlobalStyle } from 'styled-components';
import { expandableTags } from '~pages/api/use-expandable-tags';
const expandableTagsSelector = expandableTags.map((expandableTag) => `&[data-item-id="${expandableTag}"]`).join(',');
const GlobalStyle = createGlobalStyle `
  body {
    overscroll-behavior-y: none;
    overflow: hidden;
  }

  #app {
    height: calc(var(--vh, 1vh) * 100);
    display: flex;
    flex-direction: column;
  }

  body.redoc {
    overflow: auto;

    #app {
      height: auto;
      display: block;
    }

    .redoc-content {
      .api-content {
        .react-tabs__tab-list {
          display: none;
        }
      
        h1 {
          font-size: ${(props) => props.theme.typography.x7.fontSize} !important;
        }
      
        h2 {
          font-size: ${(props) => props.theme.typography.x4.fontSize} !important;
        }
      
        h1, h2, h3, h4, h5 {
          margin-bottom: 0 !important;
          font-weight: 700 !important;
        }
      
        h3 {
          color: ${(props) => props.theme.colors.oxfordBlue} !important;
          font-size: ${(props) => props.theme.typography.x3.fontSize} !important;
          margin-bottom: ${(props) => props.theme.spacers.x3} !important;
        }
      }
    
      .menu-content {
        border-right: 1px solid ${(props) => props.theme.colors.silverPearl};
        
        &.is-open {
          display: flex !important;
        }
        
        * {
          font-size: ${(props) => props.theme.typography.x2.fontSize} !important;
        }
    
        .hook,
        .post,
        .put,
        .get,
        .delete {
          font-size: 7px !important;
        }
      }
    
      .react-tabs__tab-panel {
        > div {
          > div:first-child {
            background-color: ${(props) => props.theme.colors.spaceCadet} !important;
            > span {
              display: none;
            }
          }
        }
      }
    
      .scrollbar-container {
        margin-top: 56px;

        > div {
          display: none;
        }

        li {
          padding: 0 ${(props) => props.theme.spacers.x3};
          margin: 0;

          label {
            padding: ${(props) => props.theme.spacers.x1_5};
            font-weight: ${(props) => props.theme.fontWeights.medium};
            border-radius: ${(props) => props.theme.radii.primary};
            line-height: 22px;
            align-items: center;

            &.active {
              background: transparent;
              color: ${(props) => props.theme.colors.celticBlue};

              &:hover {
                background: ${(props) => props.theme.colors.cultured};
              }
            }

            &.-depth0 {
              font-weight: ${(props) => props.theme.fontWeights.bold};
              color: ${(props) => props.theme.colors.oxfordBlue};
              opacity: 1;
            }
          }

          ${expandableTagsSelector} {
            position: relative;

            > label {
              padding-left: calc(${(props) => props.theme.spacers.x3} + 10px);
              position: relative;

              &.active {
                color: ${(props) => props.theme.colors.oxfordBlue};
              }

              svg {
                display: none;
              }

              &:before {
                position: absolute;
                content: "";
                width: 0px;
                height: 0px;
                top: 50%;
                left: 10px;
                transform: translateY(-50%);
                border-top: 6px solid transparent;
                border-right: none;
                border-bottom: 6px solid transparent;
                border-left: 8px solid ${(props) => props.theme.colors.oxfordBlue};
              }
            }

            &.open {
              > label {
                &:before {
                  border-top: 8px solid ${(props) => props.theme.colors.oxfordBlue};
                  border-right: 6px solid transparent;
                  border-bottom: none;
                  border-left: 6px solid transparent;
                }
              }
            }
          }

          li {
            padding: 0;
          }
        }
      }
    
      code {
        font-family: ${monospaceFont};
        border: none;
        padding: 0;
      }

      [data-section-id="tag/analyses"] {
        border-top: 1px solid rgba(0,0,0,0.2);
        margin: 35px 0 0;
      }
    }
  }
`;
export default GlobalStyle;
